<template>
  <v-dialog width="60vw" v-model="dialog">
    <template v-slot:activator="{ on, attrs }">
      <!-- <v-btn v-bind="attrs" v-on="on" @click="dialog=true" text color="#F15A24">Mudar meu plano</v-btn> -->

      <v-btn color="#F15A24" dark large v-bind="attrs" v-on="on" @click="dialog = true">
        <v-icon class="mr-2">mdi-file-document</v-icon>
        Mudar o meu plano
      </v-btn>
    </template>
    <v-card elevation="0" color="#f2f2f2" style="padding: 10px">
      <v-card-title>Nova Assinatura</v-card-title>
      <v-card-text>
        <h4>Plano Selecionado</h4>
        <v-select class="" color="#F15A24" item-color="#F15A24" prepend-inner-icon="mdi-sign-text"
          v-model="payment.plan" :items="planos" item-text="titulo" item-value="url">
        </v-select>
        <div>
          <h4>Cupom Desconto</h4>
          <div class="d-flex">

            <v-text-field filled hide-details label="Cupom de desconto" v-model="coupon"
              prepend-inner-icon="mdi-ticket-percent" color="#F15A24" name="discount-coupon" :rules="couponRules"
              :class="{
                'error--text': !couponIsValid && couponTouched,
                'error--background': !couponIsValid && couponTouched,
              }" @input="verifyCoupon" @focus="couponTouched = true" />
            <v-text-field filled v-if="coupon === `CAARJOAB10` && couponIsValid" color="#F15A24"
              prepend-inner-icon="mdi-file-document-edit-outline" v-model="customer.doc_cupom"
              label="Inclua número da OAB, Carteira da CAARJ ou Cartão Digital da CAARJ."></v-text-field>
          </div>
          <p v-if="couponSeleted.parceiro_cupom">
            <b>{{ couponSeleted.parceiro_cupom }}</b>: Desconto de
            {{ couponSeleted.desconto_cupom }}{{ couponSeleted.tipo === `percentage` ? `%` : ` reais` }}
            nas próximas
            {{ couponSeleted.ciclos }}
            mensalidade{{ couponSeleted.ciclos > 1 ? `s` : `` }}.
          </p>
          <div v-if="payment.plan !== 'plano-free'">
            <h4 class="mt-6">Cartão para assinatura</h4>
            <v-select :items="metodos" :item-color="`#F15A24`" color="#F15A24" item-text="title" item-value="value"
              hide-details v-model="customer.payment_method" filled label="Método de pagamento"></v-select>
            <v-text-field style="width: 100%" color="#F15A24" hide-details filled label="Nome do Titular"
              v-model="payment.holder_name" prepend-inner-icon="mdi-account-credit-card" name="holder-name">
            </v-text-field>
            <v-text-field style="width: 100%" color="#F15A24" hide-details filled label="CPF do Titular"
              v-mask="'###.###.###-##'" v-model="payment.document" prepend-inner-icon="mdi-card-account-details"
              name="holder-document">
            </v-text-field>
            <v-text-field style="width: 100%" color="#F15A24" hide-details filled v-mask="'#### #### #### ####'"
              prepend-inner-icon="mdi-credit-card" label="Número do cartão" v-model="payment.number" name="card-number">
            </v-text-field>
            <div class="d-flex">
              <v-text-field style="width: 50%" color="#F15A24" hide-details prepend-inner-icon="mdi-calendar-month" filled
                v-mask="'##/####'" label="Data Expiração (MM/AAAA)" name="card-exp-month" v-model="payment.exp_month">
              </v-text-field>
              <v-text-field style="width: 50%" color="#F15A24" hide-details filled v-mask="'###'" label="CVV"
                prepend-inner-icon="mdi-numeric" v-model="payment.cvv" name="cvv">
              </v-text-field>
            </div>

            <v-text-field v-show="false" style="width: 100%" color="#F15A24" type="hidden" filled
              prepend-inner-icon="mdi-flag" label="address_id" v-model="customer.address.id" name="billind-address-id">
            </v-text-field>
          </div>
          <v-alert v-else type="info" class="mt-6" outlined>
            <strong>Plano Gratuito</strong><br>
            Ao selecionar o plano gratuito, você não precisará informar dados de cartão de crédito.
          </v-alert>
        </div>
        <div v-if="errors.length > 0">
          <p class="red--text font-weight-medium mb-1" v-for="(err, i) in errors" :key="`errPayment${i}`">
            <v-icon color="red" small>mdi-circle-small</v-icon> {{ err.message }}
          </p>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn class="mx-auto" :loading="loadingSub" color="#F15A24" dark @click="tokenCard()">
          <v-icon>{{ payment.plan === 'plano-free' ? 'mdi-check' : 'mdi-plus' }}</v-icon> 
          {{ payment.plan === 'plano-free' ? 'Alterar para Plano Gratuito' : 'Criar Assinatura' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "PaymentDialog",
  props: { reloadSub: Function, address: Object },
  data() {
    return {
      dialog: false,
      loadingSub: false,
      e1: 1,
      loading: false,
      coupon: null,
      validCoupons: [],
      couponIsValid: false,
      couponTouched: false,
      newPayment: false,
      payment: { holder_name: "", plan: 'plano-carreira', exp_month: "", cvv: "", document: "", number: "" },
      errors: [],
      metodos: [
        { title: "Cartão de Crédito", value: "credit_card" },
        { title: "Cartão de Débito", value: "debit_card" }
      ],
      customer: {
        address: {
          zip_code: ""
          // 	country: "BR",
          // 	state: "SP",
          // 	city: "Sao Jose dos Campos",
          // 	line_1: "Travessa Jamil David",
          // 	line_2: "",
        },
        phones: {
          //   mobile_phone: {
          // 		country_code: "55",
          // 		area_code: "12",
          // 		number: "999999999",
          //   },
        },
        // birthdate: "1991/07/05",
        name: "",
        // email: "mteixeira.dev@gmail.com",
        // document: "93095135270",
        document_type: "CPF",
        type: "individual",
        payment_method: "credit_card",
        email: ""
      },

      couponSeleted: {},
      planos: [
        {
          id: 'plan_free',
          titulo: 'Plano Free (R$ 0,00)',
          url: 'plano-free',
        },
        {
          // id: "plan_XV7BG26TbcJoKxYv", //pagarme MyLegis
          id: "plan_48jmqoxfpH5OzQ0P", // pagarme RAGA
          // id: "plan_1gknGVKCwC4vleX3", //pagarme test RAGA
          titulo: "Plano Carreira 10GB (R$ 14,90)",
          url: "plano-carreira"
        },
        {
          // id: "plan_3B1DKr3HVqUp8LG5", ///pagarme mylegis
          id: "plan_vZJkelpIwIyeNq1M", // pagarme RAGA
          titulo: "Plano Premium 50GB (R$ 49,90)",
          url: "plano-premium",
        },
        {
          id: 'plan_g3180ooh6OSo0Wzx', // pagarme
          titulo: 'Plano Legislativo (R$ 499,90)',
          url: 'plano-legislativo',
        },
        {
          id: 'plan_lay6XlycO4TJw6e1',
          titulo: 'Plano Patrocínio (R$ 89,90)',
          url: 'plano-patrocinio',
        },
      ],
      planosDetalhes: {
        'plano-carreira': [
          'Crie até 10 vade-mécuns',
          'Adicione comentários e mídias em cada dispositivo legal (posts privados).',
          'Publique posts públicos (para toda a plataforma) entre amigos e grupos de amigos.',
          'Curta e comente posts públicos na rede social jurídica.',
          'Crie e participe de grupos.',
          'Importe posts de terceiros para seus vade-mécuns.',
          'Crie e importe vade-mécuns públicos.',
          'Pesquise por termos específicos nas legislações do vade-mécum.',
          'Organize seus documentos.',
        ],
        'plano-premium': [
          'Crie até 50 vade-mécuns',
          'Adicione comentários e mídias em cada dispositivo legal (posts privados).',
          'Publique posts públicos (para toda a plataforma) entre amigos e grupos de amigos.',
          'Curta e comente posts públicos na rede social jurídica.',
          'Crie e participe de grupos.',
          'Crie grupos com restricao de divulgação de conteudo.',
          'Importe posts de terceiros para seus vade-mécuns.',
          'Crie e importe vade-mécuns públicos.',
          'Pesquise por termos específicos nas legislações do vade-mécum.',
          'Organize seus documentos.',
        ],
        'plano-legislativo': [
          'Crie até 100 vade-mécuns',
          'Adicione comentários e mídias em cada dispositivo legal (posts privados).',
          'Publique posts públicos (para toda a plataforma) entre amigos e grupos de amigos.',
          'Curta e comente posts públicos na rede social jurídica.',
          'Crie e participe de grupos.',
          'Crie grupos com restricao de divulgação de conteudo.',
          'Importe posts de terceiros para seus vade-mécuns.',
          'Crie e importe vade-mécuns públicos.',
          'Pesquise por termos específicos nas legislações do vade-mécum.',
          'Organize seus documentos.',
          'Acesso prioritário a novas funcionalidades.',
        ],
        'plano-patrocinio': [
          'Benefícios do plano de patrocínio',
        ],
      }
    }
  },
  mounted() {
    this.getCoupons()
  },
  methods: {
    formattedCurrentDay() {
      const currentDay = new Date();
      let formattedDay = currentDay.toISOString();
      formattedDay = formattedDay.slice(0, 10);
      const currentHour = currentDay.toLocaleTimeString("pt-BR");
      return `${formattedDay}T${currentHour}`;
    },
    async getCoupons() {
      // window.console.log(`pegou cupoms`)
      try {
        const currentDay = this.formattedCurrentDay();
        const {
          data: { data },
        } = await this.$http.get(
          `items/cupom?filter[expire_date][_gt]=${currentDay}`
        );

        this.validCoupons = data;
        const isValid = this.validCoupons.find((el) => el.parceiro_cupom.toUpperCase() === `LANCAMENTO10`)
        this.couponIsValid = !!isValid;
        this.couponSeleted = this.couponIsValid ? isValid : {}
        this.coupon = this.couponIsValid ? `LANCAMENTO10`.toUpperCase() : ``
        // window.console.log(data);
      } catch (error) {
        window.console.error(error);
      }
    },
    async verifyCoupon() {
      const isValid = this.validCoupons.find(
        (el) => el.parceiro_cupom.toUpperCase() === this.coupon.toUpperCase()
      );
      window.console.log(isValid)
      this.couponIsValid = !!isValid;
      this.couponSeleted = this.couponIsValid ? isValid : {}
      if (this.coupon.length === 0) {
        this.couponIsValid = true;
      }
    },
    sanitizeCard() {
      this.payment.document = this.payment.document.replace(/[^\d]/g, "");
      this.payment.number = this.payment.number.replace(/\s/g, "");
    },
    sanitizeCustomer() {
      const regex = /^\((\d{2})\)\s*(\d{4,5})-(\d{4})$/;
      const match = this.customer.telephone.match(regex);

      if (match[2].length === 4) {
        this.customer.phones.home_phone = {};
        this.customer.phones.home_phone.area_code = match[1];
        this.customer.phones.home_phone.number = match[2] + match[3];
        this.customer.phones.home_phone.country_code = "55";
      } else if (match[2].length === 5) {
        this.customer.phones.mobile_phone = {};
        this.customer.phones.mobile_phone.area_code = match[1];
        this.customer.phones.mobile_phone.number = match[2] + match[3];
        this.customer.phones.mobile_phone.country_code = "55";
      }

      this.customer.document = this.customer.document.replace(/[^\d]/g, "");
      this.customer.address.zip_code = this.customer.address.zip_code.replace(
        /[^\d]/g,
        ""
      );
      this.customer.address.line_1 = `${this.address.number},${this.address.line_1},${this.address.neighborhood}`;
    },
    tokenCard() {
      // Se está mudando para plano free, mostrar alerta de confirmação
      if (this.payment.plan === "plano-free" && this.user.plano && this.user.plano !== "plano-free") {
        this.confirmarMudancaParaFree();
        return;
      }

      if (this.payment.plan !== "plano-free") {
        // window.console.log(this.payment)
        if (this.payment.exp_month.length < 7) {
          alert("Por favor insira a validade no formado MM/AAAA.")
          return
        }
        if (this.payment.cvv.length < 3) {
          alert("Por favor insira o códivo de validação de tres digitos.")
          return
        }
        this.loadingSub = true
        this.errors = []
        this.sanitizeCard();
        let month = this.payment.exp_month.split("/")[0];
        let year = this.payment.exp_month.split("/")[1];

        this.customer.address.zip_code = this.customer.address.zip_code.replace(/[^\d]/g, "");
        this.customer.address.line_1 = `${this.address.number},${this.address.line_1},${this.address.neighborhood}`;
        this.$http
          .post("payment/cards/" + this.user.customer_id, {
            card: {
              number: this.payment.number,
              holder_name: this.payment.holder_name,
              holder_document: this.payment.document,
              exp_month: parseInt(month),
              exp_year: parseInt(year),
              cvv: this.payment.cvv,
              billing_address: {
                zip_code: this.address.cep.replace(/[^\d]/g, ""),
                country: this.address.pais,
                state: this.address.estado,
                city: this.address.cidade,
                line_1: `${this.address.numero},${this.address.rua},${this.address.bairro}`,
                line_2: this.address.complemento,
              }
            },
          })
          .then((res) => {
            this.payment.cardToken = res.data.id;
            this.postSubscription();
          }).catch((err) => {

            this.loadingSub = false
            this.errors.push(err.response.data.errors[0])
          });
      } else {
        // Se já está no plano free, apenas atualizar
        this.mudarParaPlanoFree();
      }
    },
    confirmarMudancaParaFree() {
      const planoAtual = this.user.plano;
      const beneficios = this.planosDetalhes[planoAtual] || [];
      
      let mensagem = "⚠️ ATENÇÃO: Ao mudar para o plano gratuito, você perderá os seguintes benefícios do seu plano atual:\n\n";
      
      if (beneficios.length > 0) {
        // Mostrar apenas os primeiros 5 benefícios mais importantes
        const beneficiosPrincipais = beneficios.slice(0, 5);
        beneficiosPrincipais.forEach((beneficio, index) => {
          mensagem += `• ${beneficio}\n`;
        });
        if (beneficios.length > 5) {
          mensagem += `\n... e mais ${beneficios.length - 5} benefícios.\n`;
        }
      } else {
        mensagem += "• Todos os benefícios do seu plano atual\n";
      }
      
      mensagem += "\n\nDeseja realmente prosseguir com a mudança para o plano gratuito?";
      
      if (confirm(mensagem)) {
        this.mudarParaPlanoFree();
      }
    },
    mudarParaPlanoFree() {
      this.loadingSub = true;
      // Cancelar assinaturas ativas primeiro, depois atualizar o plano
      this.$http.get("payment/subscriptions")
        .then((response) => {
          const subscriptions = response.data.filter(
            (sub) => sub.status !== "canceled"
          );
          
          // Cancelar todas as assinaturas ativas
          const cancelPromises = subscriptions.map((sub) =>
            this.$http.delete(`payment/subscriptions/${sub.id}`)
          );
          
          Promise.all(cancelPromises)
            .then(() => {
              // Atualizar o plano do usuário para free
              return this.$http.patch("users/" + this.user.id, { plano: "plano-free" });
            })
            .then(() => {
              this.loadingSub = false;
              this.dialog = false;
              alert("Plano alterado para gratuito com sucesso!");
              this.$store.dispatch("getInfo");
              if (this.reloadSub) {
                this.reloadSub();
              }
            })
            .catch((err) => {
              window.console.error(err);
              // Tentar atualizar o plano mesmo se houver erro ao cancelar
              this.$http.patch("users/" + this.user.id, { plano: "plano-free" })
                .then(() => {
                  this.loadingSub = false;
                  this.dialog = false;
                  alert("Plano alterado para gratuito. Algumas assinaturas podem ainda estar ativas. Entre em contato com o suporte se necessário.");
                  this.$store.dispatch("getInfo");
                  if (this.reloadSub) {
                    this.reloadSub();
                  }
                })
                .catch((updateErr) => {
                  window.console.error(updateErr);
                  this.loadingSub = false;
                  alert("Erro ao alterar plano. Tente novamente.");
                });
            });
        })
        .catch((err) => {
          window.console.error(err);
          // Se não conseguir buscar assinaturas, tentar atualizar o plano mesmo assim
          this.$http.patch("users/" + this.user.id, { plano: "plano-free" })
            .then(() => {
              this.loadingSub = false;
              this.dialog = false;
              alert("Plano alterado para gratuito com sucesso!");
              this.$store.dispatch("getInfo");
              if (this.reloadSub) {
                this.reloadSub();
              }
            })
            .catch((updateErr) => {
              window.console.error(updateErr);
              this.loadingSub = false;
              alert("Erro ao alterar plano. Tente novamente.");
            });
        });
    },
    postSubscription() {
      this.loadingSub = true
      let planSelected = this.planos.find((p) => p.url === this.payment.plan);
      const subscription = {
        plan_id: planSelected.id,
        payment_method: this.customer.payment_method,
        customer_id: this.user.customer_id,
        card_id: this.payment.cardToken,
      };

      if (this.couponIsValid) {
        const couponData = this.validCoupons.find(
          (el) => el.parceiro_cupom.toUpperCase() === this.coupon.toUpperCase()
        );

        subscription.discounts = [
          {
            cycles: couponData.ciclos,
            discount_type: couponData.tipo,
            value: `${couponData.desconto_cupom}`,
          },
        ];
      }

      this.$http
        .post("payment/subscriptions", {
          subscription,
        })
        .then((res) => {
          if (res.data.status !== "failed") {
            alert("Parabéns você agora é um novo membro do MyLegis");
            this.loadingSub = false
            this.dialog = false
            this.$http.patch("users/" + this.user.id, { plano: planSelected.url }).then(() => { })
            this.reloadSub()
            // this.on = false
          }
          else {
            this.loadingSub = false
            alert("Ocorreu um erro no pagamento confira os dados e tente novamente.");
          }
        }).catch((err) => {
          window.console.log(err)
          this.errors = err.response.data.errors
          this.loadingSub = false
        });
    },
  },
  computed: {
    user() {
      // window.console.log(this.$store.state.user.avatar)
      return this.$store.state.user != undefined
        ? this.$store.state.user
        : { first_name: "Meu Perfil" };
    },
    couponRules() {
      return [
        // (value) => !!value || "Digite um cupom de desconto",
        () =>
          !this.couponTouched ||
          this.couponIsValid ||
          "Cupom de desconto inválido",
      ];
    },
  }
}
</script>